import { GiftCardsUtilService } from '@core/services/ib-gift-cards-utils.service';
import { RedirectionLandingService } from '@core/services/ib-gift-cards-redirection-service';
import { GiftCardsConfigurationService } from '@src/app/features/pages/configuration/services/ib-gift-cards-configuration/ib-gift-cards-configuration-service';
import { cloneDeep } from 'lodash-es';
import * as angular from 'angular';

const componentOptions = {
    bindings: {
        model: '='
    },
    controllerAs : 'giftCardsConfigurationFormCtrl',
    templateUrl: ['GiftCardsAppConstants', (GiftCardsAppConstants: GiftCardsAppConstant): string => `${GiftCardsAppConstants.templatesRoute}ib-gift-cards-configuration-form-view.html`]
};
const componentInfo = {
    module: 'ib-gift-cards-configuration-form-module',
    selector: 'ibGiftCardsConfigurationForm',
    inject:['localStorageService',
        'GiftCardsAppConstants',  'GiftCardsConfigurationService',
        'CommonsModalService',  'RedirectionLandingService', 'GiftCardsUtilService',
        'DatalayerUtilsService', 'DigitalDataService',
        'CommonsUtilService', '$filter', '$rootScope', '$timeout'],
    required: ['ib-gift-cards-service-module']
};
export class ibGiftCardsConfigurationForm implements ng.IController {
    public model: Types.ConfigurationModel ;
    public form: any;
    public importError: boolean = false;
    public extendedObject: any = {};
    public flow: string = 'configuration';
    public showBannerTRCDiscount: boolean = false;
    constructor (
        private localStorageService: angular.local.storage.ILocalStorageService,
        private GiftCardsAppConstants: GiftCardsAppConstant,
        private GiftCardsConfigurationService: GiftCardsConfigurationService,
        private CommonsModalService: any,
        private RedirectionLandingService: RedirectionLandingService,
        private GiftCardsUtilService: GiftCardsUtilService,
        private DatalayerUtilsService:DatalayerUtilsService,
        private DigitalDataService: any,
        private CommonsUtilService: CommonsUtilService,
        private $filter: ng.IFilterService, private $rootScope, private $timeout) {
            
    }

    $onInit () {
        this.saveDestiny('REGOTR');
        this.$watchModel();
    }

    $watchModel () {
        const unbindWatch = this.$rootScope.$watch(
            () => this.model,
            (newVal, oldVal) => {
                if (newVal !== oldVal && newVal) {
                    this.showBannerIfDiscountAndHasAvailabilityTRC();
                    unbindWatch();
                }
            }
        );
    }
    showBannerIfDiscountAndHasAvailabilityTRC = () => {
        const hasTRC = this.model.importInfo.groupFixedPrices && this.model.importInfo.groupFixedPrices.length > 0;
        const hasTRCollaborativeDiscount = !this.model.importInfo.groupFixedPrices?.some(item => item.discount !== null);
        const hasTRIndividualDiscount = this.model.importInfo.fixedPrices?.some(item => item.discount !== null);
        this.showBannerTRCDiscount = (hasTRC && hasTRCollaborativeDiscount && hasTRIndividualDiscount);
    };
    firstElementPriceChecked  = () => {
        this.$rootScope.$broadcast('changeFixedPriceSelected');
        
        this.setConditionsTypeSelected();
    };
    setConditionsTypeSelected = () => {
        this.$timeout(() => {
            const firstPriceName = this.model.participationCheckboxGroup == 'true' ? this.model.importInfo.groupFixedPrices[0].name : this.model.importInfo.fixedPrices[0].name;
            this.$rootScope.$broadcast('setConditions', firstPriceName);
        }, 200);
    };
    saveDestiny = (destiny:string) => {
        this.localStorageService.set('giftCardDestiny', destiny);
        const cardDestiny:string = this.GiftCardsUtilService.setQuadrigamInfo();
        const step: string = this.GiftCardsAppConstants?.QUADRIGAM_STEPS.SELECCION;
        let codigoSeguimientoOld:string = this.localStorageService.get('TrackingCode');
        let codigoSeguimientoSplit = codigoSeguimientoOld.split('/')[2] = cardDestiny;
        let codigoSeguimientoNew = codigoSeguimientoOld.split('/')[0] + '/' + codigoSeguimientoOld.split('/')[1] + '/' + codigoSeguimientoSplit;

        if(destiny === 'REGMIO') {
            this.localStorageService.remove('cardDestiny');
            this.localStorageService.remove('theme');
            this.CommonsUtilService.setTitlePage('GIFT_CARD_CONFIGURATION_REGMIO_TITLE');
        }else{
            this.localStorageService.set('cardDestiny', destiny);
            this.CommonsUtilService.setTitlePage('GIFT_CARD_CONFIGURATION_REGOTR_TITLE');
        }
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(cardDestiny, null, this.GiftCardsUtilService.isUserLogged());
        this.DigitalDataService.addDigitalDataInfo({TrackingCode: codigoSeguimientoNew, Quadrigam: cardDestiny, Step: step});
        this.DatalayerUtilsService.sendDatalayerEvent(this.GiftCardsAppConstants.DATALAYER_EVENT_TYPES.VIEW);
        this.DigitalDataService.emitViewEvent();
        this.$timeout(() => {
            this.$rootScope.$broadcast('sendUpdateToMonetate');
            this.$rootScope.$broadcast('updateDatalayer');            
            this.$rootScope.$broadcast('updateDigitalData');
        });

    };

    generateInfoToModal = (isGroupCard): Types.ConfigurationModel  =>{
        const modelCopy = cloneDeep(this.model);
        
        let info;
        if(!isGroupCard){
            info = {
                allConditionsEquals: modelCopy.importInfo.allConditionsEquals,
                campaigns: modelCopy.importInfo.conditionInfo.campaigns === null ? null:
                    [modelCopy.importInfo.conditionInfo.selectedCondition]
            };
        }else {
            info = modelCopy;
            let dateTemp = info.shippingInfo.delivery.dateTime.split('-');
            info.shippingInfo.delivery.dateTime = `${dateTemp[2].slice(0, 2)}/${dateTemp[1]}/${dateTemp[0]}`;
        }
        return info;
    };
    completeForm = () :void => {
        this.form.$submitted = true;
        this.importError =false;
        if (this.form.$valid) {
            if(this.model.importGift) {
                this.extendedObject = {
                    currency : this.model.importInfo.currency.code,
                    importeTarjetaRegalo: this.model.importGift.amount
                };

                if(this.model.importGift.discount) {
                    this.extendedObject.importePagoCliente = this.model.importGift.discount.amount;
                }
            }
            this.importError = this.model.importGift === null;
            if( this.form.customAmount?.$error && this.form.customAmount?.$error?.pattern &&
                this.form.customAmount?.$error?.pattern === true) {
                this.importError =false;
            }
            if(this.importError) {
                angular.element('html,body').animate({ scrollTop: 'divImportError' }, 'slow');
                return;
            }
            

            let info = this.model.participationCheckboxGroup == 'true' ? this.generateInfoToModal(true) : this.generateInfoToModal(false);
            const template :string = this.model.participationCheckboxGroup == 'true' ? 'ib-modal-one-card-conditions-group.html' : 'ib-modal-one-card-conditions.html';
            
            if(this.model.participationCheckboxGroup == 'true'){
                const campaignIdSelected = this.model.importInfo.conditionInfo.selectedCondition.campaignId; 
                this.GiftCardsConfigurationService.postMaximunDateAllowed(
                    this.GiftCardsConfigurationService.generateDataForPostMaximunDateAllowed(this.model.shippingInfo.delivery.dateTime, campaignIdSelected), this.model.importInfo.flowId).then((response) => {
                    const newDate = response.data.groupCampaigns.find(campaign => campaign.campaignId === campaignIdSelected).expiryDateTo;
                    info.importInfo.conditionInfo.selectedCondition.expiryDateTo = this.GiftCardsConfigurationService.formatDateByMarket(newDate) ;
                    this.CommonsModalService.finishWaiting();
                    this.showConditionModal(info, template);
                },
                (error)=>{
                    
                    this.CommonsModalService.showGenericError(error).result.then(angular.noop, angular.noop);
                });
            }else {
                this.showConditionModal(info, template);
            }
            
        }else{
            const errorScroll = this.model.importGift === null ?'divImportError'
                : angular.element('[name="' + this.form.$name + '"]').find('.ng-invalid:visible:first').offset()?.top - angular.element('.ib-header-common--full-container').innerHeight();
            this.importError = this.model.importGift === null;
            angular.element('html,body').animate({ scrollTop: errorScroll }, 'slow');
        }
    };

    showConditionModal = (info, template) => {
        this.CommonsModalService.openBuildGenericModal(
            info,
            template,
            'ib-modals--large-gift-card',
            'ibModalConditionsController'
        ).result.then(():void =>{
            this.goToPayment();
        }, ():void =>{
        });
    };

    cancel = () :void=>{
        this.CommonsModalService.showGenericModal(true, 'ib-modal-back-gift-cards.html',
            { idModal: this.GiftCardsAppConstants.GIFT_CARDS_BACK }, null).result.then( () => {
            this.RedirectionLandingService.redirection(this.GiftCardsAppConstants.market.toLowerCase(), this.GiftCardsAppConstants.lang.toUpperCase());
        }, angular.noop);

    };

    openConditions = () :void => {
        const conditionsInfoRoute = this.model.participationCheckboxGroup == 'true' ? 'groupAllConditionsEquals' : 'allConditionsEquals';
        const template :string = this.model.importInfo.conditionInfo[conditionsInfoRoute] ? 'ib-modal-one-card-conditions.html' : 'ib-modal-some-cards-conditions.html';
        this.CommonsModalService.openBuildGenericModal(
            this.model,
            template,
            'ib-modals--large',
            'ibModalConditionsController'
        );

    };

    goToPayment = ():void =>{
        this.CommonsModalService.showWaitingModal('ib-modal-loading-plane',
            'ib-modals ib-modals--transparent ib-modals--loading-page', true, null );
        this.localStorageService.set('giftCardsFlowId', this.model.importInfo.flowId);
        this.GiftCardsConfigurationService.putGiftCard(
            this.GiftCardsConfigurationService.transformData(this.model),
            this.model.importInfo.flowId,
            this.extendedObject
        ).then(() => {},
            (error)=>{
                this.CommonsModalService.finishWaiting();
                this.CommonsModalService.showGenericError(error).result.then(angular.noop, angular.noop);
            });
    };
}
try {
    const mod = angular.module(componentInfo.module);
    ibGiftCardsConfigurationForm.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsConfigurationForm })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibGiftCardsConfigurationForm.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsConfigurationForm })
    );
}
